import { defineComponent } from "vue";
import Popup from "../../share/popup";

import "./expire.less";

export default defineComponent({
  emits: ["confirm"],
  props: {
    visible: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const onConfirmClick = () => {
      emit("confirm");
    };

    return () => (
      <Popup closeOnOverlayClick={false} position="center" visible={props.visible} width={320}>
        <div class="feiyu-web-service-pay-expire">
          <div class="feiyu-web-service-pay-expire--content">{"当前订单已失效，请重新下单"}</div>
          <div class="feiyu-web-service-pay-expire--button" onClick={onConfirmClick}>
            {"确定"}
          </div>
        </div>
      </Popup>
    );
  },
});
